import React, { useContext, useEffect } from 'react';
import { useCtxValue, OpenLink, setSessionForKey } from 'helpers';
import _ from 'lodash';
import atoms from 'ctsutheme/components/atoms';
// import molecules from 'ctsutheme/components/molecules';
import ProtocolInfoButton from '@ctsu/protocol-i-button';
import { getToken, AppContext } from '@ctsu/loader';
import { history } from 'stores/store';
import { FasQuestionCircle } from 'assets/icons';
import { CTSUCardActions } from './CTSUCardActions';

const { Tooltip, IconButton } = atoms;

const style = {
  fontSize: '.75rem',
  color: '#AB0731'
};

export { CTSUCardActions };


export const ProtocolIButton = ({ protocolNumber }) => (
  <ProtocolInfoButton
    id={protocolNumber}
    protId={protocolNumber}
    getToken={getToken}
    color="rgb(19, 128, 143)"
    smallSize
  />
);

export const ProtocolHelpLink = () => {
  const link = useCtxValue('CTSU_PROTOCOLS_USER_GUIDE');
  return (
    <Tooltip
      tooltipplacementbottom="true"
      title="Protocol Help Link"
      aria-label="Protocol Help Link"
    >
      <IconButton
        key="Protocol-Help-Link"
        aria-label="Protocol Help Link"
        color="inherit"
        onClick={() => OpenLink(link)}
      >
        <FasQuestionCircle />
      </IconButton>
    </Tooltip>
  );
};


export const ErrorMessage = ({ msg }) => <div style={style}>{msg}</div>;

export const NoMatch = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    const { session } = context;
    history.push({
      pathname: session != null ? '/' : 'login'
    });
  }, [context]);
  return null;
};

export const Loading = () => (
  <h2>
    Please wait while your page is loading...
  </h2>
);

export const NoChartDataFound = () => (
  <span>No data found for chart</span>
);

export const NoDataFound = () => (
  <span style={{ display: 'inline-block', paddingBottom: '1rem' }}>No record(s) Found</span>
);


export const FallBackError = () => (
  <div className="loading-error bg-red-lighter color-red rounded p-2 my-1">
    Oops! Something went wrong!!!
  </div>
);

export const CTSULoadingError = ({ compName }) => (
  <div className="loading-error">
    We are unable to load
    {' '}
    {compName}
    {' '} at this time. Please contact the <a href={`mailto:ctsucontact@westat.com?subject=Error Loading ${compName}`}>CTSU Help Desk</a>
  </div>
);


// export const CTSULoadingSpinner = () => (
//   <>
//     <div className="loading-spinner-wrapper">
//       <div className="loading-spinner-icon">
//         <span className="invisible">Page is Loading. Please wait.</span>
//       </div>
//     </div>
//   &nbsp;&nbsp;
// Loading...
//   </>
// );

export const CTSULoadingSpinner = () => (
  <div>
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fad"
      data-icon="spinner-third"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="fa-spinner-third color-turquoise mx-1 spin-animation"
    >
      <g className="fa-group">
        <path
          fill="currentColor"
          d="M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z"
          style={{ opacity: '.25' }}
        />
        <path
          fill="currentColor"
          d="M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z"
          className="fa-primary"
        />
      </g>
    </svg>
    Loading...
  </div>
);

export const BoolToString = ({ boolValue }) => {
  if (boolValue === true) {
    return <span className="font-bold">Yes</span>;
  }

  if (boolValue === false) {
    return <>No</>;
  }

  return '';
}

export const GetEmptyValue = ({ value }) => (value || '');

export const RegTypeOrder = ['IVR', 'NPIVR', 'AP', 'A', 'AB'];

export function SortedRegTypeOrder(value) {
  return _.sortBy(value, (item) => RegTypeOrder.indexOf(item));
}

export const InitAppSession = ({ session, application }) => {
  // Keep Console Statements for-now
  // console.log(application);
  // console.log(session);

  const { UserSelProtocols } = (session && session.userData) || {};

  setSessionForKey('environment', application && application.dbName);
  setSessionForKey('prt_url_ver', useCtxValue('PROTOCOL_API_VERSION'));
  setSessionForKey('site_url_ver', useCtxValue('SITE_API_VERSION'));
  setSessionForKey('esys_url_ver', useCtxValue('ESYS_API_VERSION'));
  setSessionForKey('edoc_not_found', useCtxValue('PROTOCOL_DOC_NOT_FOUND'));
  setSessionForKey('user_recent_protocols', UserSelProtocols);

  return null;
};
